import request from '@/utils/request'
import { wisdomsitePrefix } from './config'

// 人脸识别
export function siteVerifyPersonRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyPersonRecord/listByProject',
    method: 'post',
    data
  })
}
export function querySiteVerifyPersonRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyPersonRecord/query',
    method: 'post',
    data
  })
}
export function SiteVerifyPersonRecordExportByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyPersonRecord/exportByProject',
    method: 'post',
    data
  })
}
export function siteVerifyPersonRecordAdd(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyPersonRecord/add',
    method: 'post',
    data
  })
}
export function siteVerifyCertRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyCertRecord/listByProject',
    method: 'post',
    data
  })
}
export function siteVerifyCertRecordExportByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyCertRecord/exportByProject',
    method: 'post',
    data
  })
}
export function siteVerifyOutInRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyOutInRecord/listByProject',
    method: 'post',
    data
  })
}
export function outInDetailPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyOutInRecord/outInDetailPageList',
    method: 'post',
    data
  })
}
export function siteVerifyOutInRecordHorizontal(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyOutInRecord/listByHorizontal',
    method: 'post',
    data
  })
}
export function siteVerifyOutInRecordExportByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyOutInRecord/exportByProject',
    method: 'post',
    data
  })
}
export function exportDetailRecordByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyOutInRecord/exportDetailRecordByProject',
    method: 'post',
    data
  })
}
export function siteVerifyOutInRecordExportByHorizontal(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyOutInRecord/exportByHorizontal',
    method: 'post',
    data
  })
}
export function siteVerifyDetailRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyDetailRecord/listByProject',
    method: 'post',
    data
  })
}
export function siteVerifyDetailRecordExportByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyDetailRecord/exportByProject',
    method: 'post',
    data
  })
}
export function siteVerifyStrangerRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyStrangerRecord/listByProject',
    method: 'post',
    data
  })
}
export function siteVerifyStrangerRecordExportByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyStrangerRecord/exportByProject',
    method: 'post',
    data
  })
}
export function querySiteVerifyCertRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyCertRecord/query',
    method: 'post',
    data
  })
}
export function siteYcjzDeviceQueryStatisticList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteYcjzDevice/queryStatisticList',
    method: 'post',
    data
  })
}
export function exportYcjzStatisticList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteYcjzDevice/exportYcjzStatisticList',
    method: 'post',
    data
  })
}

// 车牌识别

export function queryThroughStatistics(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprRecord/queryThroughStatistics',
    method: 'post',
    data
  })
}
export function exportThroughStatistics(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprRecord/exportThroughStatistics',
    method: 'post',
    data
  })
}
export function queryAccessRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprRecord/queryAccessRecordList',
    method: 'post',
    data
  })
}
export function exportAccessRecordDetail(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprRecord/exportAccessRecordDetail',
    method: 'post',
    data
  })
}
export function queryThroughRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprRecord/queryThroughRecordList',
    method: 'post',
    data
  })
}
export function exportThroughRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprRecord/exportThroughRecordList',
    method: 'post',
    data
  })
}
export function queryStrangeRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprRecord/queryStrangeRecordList',
    method: 'post',
    data
  })
}

// 塔吊
export function siteCraneDeviceQueryAlarmDataPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/queryAlarmDataPageList',
    method: 'post',
    data
  })
}
export function siteCraneDeviceQueryRealtimePageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/queryRealtimePageList',
    method: 'post',
    data
  })
}
export function exportCraneRealtimePage(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/exportCraneRealtimePage',
    method: 'post',
    data
  })
}
export function siteCraneDeviceQueryWorkDataPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/queryWorkDataPageList',
    method: 'post',
    data
  })
}
export function siteCraneDeviceExportCraneWorkDataPageList(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteCraneDevice/exportCraneWorkDataPageList',
    method: 'post',
    data
  })
}
export function siteCraneDeviceExportCraneAlarmDataPageList(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteCraneDevice/exportCraneAlarmDataPageList',
    method: 'post',
    data
  })
}

// 升降机
export function siteElevatorDeviceQueryAlarmDataPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/queryAlarmDataPageList',
    method: 'post',
    data
  })
}
export function siteElevatorDeviceQueryRealtimePageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/queryRealtimePageList',
    method: 'post',
    data
  })
}
export function siteElevatorDeviceExportElevatorRealtimePage(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteElevatorDevice/exportElevatorRealtimePage',
    method: 'post',
    data
  })
}
export function siteElevatorDeviceExportElevatorWorkDataPageList(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteElevatorDevice/exportElevatorWorkDataPageList',
    method: 'post',
    data
  })
}
export function siteElevatorDeviceExportElevatorAlarmDataPageList(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteElevatorDevice/exportElevatorAlarmDataPageList',
    method: 'post',
    data
  })
}

export function siteElevatorDeviceQueryWorkDataPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/queryWorkDataPageList',
    method: 'post',
    data
  })
}
export function exportAepRealtimeLog(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/exportAepRealtimeLog',
    method: 'post',
    data
  })
}
export function siteVerifyTemporaryRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyTemporaryRecord/queryPage',
    method: 'post',
    data
  })
}
export function siteVerifyTemporaryRecordExport(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyTemporaryRecord/export',
    method: 'post',
    data
  })
}
// 项目下的参建单位班组及人员
export function companyTeamAndPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProject/companyTeamAndPerson',
    method: 'post',
    data
  })
}

export function siteElevatorVerifyPersonRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorVerifyPersonRecord/pageList',
    method: 'post',
    data
  })
}

export function exportSiteElevatorVerifyPersonRecord(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteElevatorVerifyPersonRecord/exportByProject',
    method: 'post',
    data
  })
}

export function siteCraneVerifyPersonRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneVerifyPersonRecord/pageList',
    method: 'post',
    data
  })
}

export function exportSiteCraneVerifyPersonRecord(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteCraneVerifyPersonRecord/exportByProject',
    method: 'post',
    data
  })
}

export function siteCollectorPersonRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCollectorPersonRecord/pageList',
    method: 'post',
    data
  })
}
export function exportSiteCollectorPersonRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCollectorPersonRecord/export',
    method: 'post',
    data
  })
}
export function siteAiBoxAlarmRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBoxAlarmRecord/pageByProject',
    method: 'post',
    data
  })
}
export function siteVerifyDetailRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyDetailRecord/pageList',
    method: 'post',
    data
  })
}
export function exportDetailByProject(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteVerifyDetailRecord/exportDetailByProject',
    method: 'post',
    data
  })
}
export function siteAreaWorkHoursRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAreaWorkHoursRecord/pageList',
    method: 'post',
    data
  })
}
export function exportSiteAreaWorkHoursRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAreaWorkHoursRecord/exportPageList',
    method: 'post',
    data
  })
}
export function siteAreaWorkHoursRecordStatisticList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAreaWorkHoursRecord/statisticPageList',
    method: 'post',
    data
  })
}
export function exportSiteAreaWorkHoursRecordStatisticList(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAreaWorkHoursRecord/exportSalaryReportByProject',
    method: 'post',
    data
  })
}
